import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

//----- store
import { fetchCardData } from "../../store/cardNotifications-actions";

import { makeStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import LoadingSpinner from "../UI/LoadingSpinner/LoadingSpinner";

import Styles from "./CardNotifications.module.css";

const useStyles = makeStyles((theme) => ({
	container: {
		maxHeight: 395,
	},
}));

const CardRunningActions = () => {
	const dispatch = useDispatch();
	const classes = useStyles();

	const isLoading = useSelector((state) => state.uiData.isLoading[6]);

	const cardNotificationsData = useSelector(
		(state) => state.cardNotificationsData
	);
	const autenticationData = useSelector(
		(state) => state.uiData.autentication
	);

	const apiConfigData = useSelector((state) => state.apiConfigData);

	const url_data =
		apiConfigData.endpoint.domain +
		apiConfigData.endpoint.dashboard.notifications;

	useEffect(() => {
		dispatch(fetchCardData(url_data, autenticationData));
	}, [dispatch]);

	useEffect(() => {
		console.log("cardNotificationsData", cardNotificationsData);
	}, [cardNotificationsData]);

	return (
		<div className={Styles["cardNotifications"]}>
			<TableContainer className={classes.container}>
				<Table stickyHeader aria-label="Table Notifications">
					<TableHead>
						<TableRow className={Styles["MuiTableRow-head"]}>
							<TableCell
								className={Styles["MuiTableCell-head"]}
								align="left"
							>
								<div
									className={Styles["title"]}
								>{`Notificações (${cardNotificationsData.cardData.length})`}</div>
							</TableCell>
							<TableCell
								className={Styles["MuiTableCell-head"]}
								align="right"
							>
								<div className={Styles["title"]}>
									{/* <button className={Styles["btn-seeMore"]}>
										Ver mais
									</button> */}
								</div>
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{!isLoading && cardNotificationsData.cardData.map((row) => (
							<TableRow
								key={row.id_Alerta}
								className={Styles["MuiTableBody-root"]}
							>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
									component="th"
									scope="row"
								>
									<div
										className={Styles["notifications-line"]}
									>
										<div
											className={`${Styles["border"]} ${Styles["seen"]}`}
										></div>
										<div>
											<div className={Styles["title"]}>
												{row.nome}
											</div>
											<div className={Styles["subtitle"]}>
												{row.alertItem.alert}
											</div>
										</div>
									</div>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
				{isLoading && (
					<div style={{ textAlign: "center" }}>
						<LoadingSpinner />
					</div>
				)}
				{cardNotificationsData.cardData.length == 0 && (
					<div className={Styles["no-record-found"]}>
						Não existem notificações
					</div>
				)}
			</TableContainer>
		</div>
	);
};

export default CardRunningActions;
